import type {DataValue, VerifiedLinkedCatalogPost} from '../types';
import {isVerifiedLinkedWorkLink} from './isVerifiedLinkedWorkLink';

export const isVerifiedLinkedWork = (
  link: DataValue | undefined,
): link is VerifiedLinkedCatalogPost =>
  isVerifiedLinkedWorkLink((link as VerifiedLinkedCatalogPost).link);
